var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import S from 's-js';
import * as Surplus from 'surplus';
import data from 'surplus-mixin-data';
import { Page } from './Page';
import { RequestErrors } from './RequestErrors';
export { LoginRoute, ReLoginPage };
const LoginRoute = (app) => __awaiter(this, void 0, void 0, function* () {
    const model = LoginModel(app, () => app.location.change('#'));
    return () => <LoginPage {...model}/>;
}), LoginModel = (app, onLogin) => {
    const email = S.data(""), password = S.data(""), request = S.data(null), submit = () => {
        request((app.requestCredentials() || app.login)(email(), password()))
            .then(resp => onLogin && onLogin());
        return false;
    };
    return { app, email, password, request, submit };
}, LoginPage = (model) => (<Page app={model.app} title="Sign in - Conduit" section={4 /* SignIn */}>
            <Login {...model}/>
        </Page>), ReLoginPage = (app) => LoginPage(LoginModel(app, () => null)), Login = (model) => (<div class="auth-page">
            <div class="container page">
                <div class="row">
                    <div class="col-md-6 offset-md-3 col-xs-12">
                        <h1 class="text-xs-center">Sign in</h1>

                        <p class="text-xs-center">
                            <a href="#/register">Need an account?</a>
                        </p>

                        <RequestErrors request={model.request}/>

                        <form onSubmit={model.submit}>
                            <fieldset class="form-group">
                                <input fn={data(model.email)} class="form-control form-control-lg" type="text" placeholder="Email"/>
                            </fieldset>
                            <fieldset class="form-group">
                                <input fn={data(model.password)} class="form-control form-control-lg" type="password" placeholder="Password"/>
                            </fieldset>
                            <button class="btn btn-lg btn-primary pull-xs-right">
                                Sign in
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>);
